import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class IdentityService extends RLBaseService {
    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    getRoleList() {
        return this.toRLService<Models.IAspNetUserRole>("/api/identity/getrolelist").query().$promise;
    }

    createRole(roleName: string, xref: string, activityPolicyID: string, dataPolicyID: string, workflowPolicyID: string, adminPolicyID: string) {
        var data = {
            roleName: roleName,
            xref: xref,
            activityPolicyID: activityPolicyID,
            dataPolicyID: dataPolicyID,
            workflowPolicyID: workflowPolicyID,
            adminPolicyID: adminPolicyID
        };
        return this.toRLService<void>("/api/identity/createrole").post(data).$promise;
    }

    updateRole(roleID: string, roleName: string, xref: string, activityPolicyID: string, dataPolicyID: string, workflowPolicyID: string, adminPolicyID: string) {
        var data = {
            roleID: roleID,
            roleName: roleName,
            xref: xref,
            activityPolicyID: activityPolicyID,
            dataPolicyID: dataPolicyID,
            workflowPolicyID: workflowPolicyID,
            adminPolicyID: adminPolicyID
        };
        return this.toRLService<void>("/api/identity/updaterole").post(data).$promise;
    }

    deleteRole(roleID: string) {
        var data = {
            roleID: roleID
        };
        return this.toRLService<void>("/api/identity/deleterole").post(data).$promise;
    }

    getUserRoles(rlUserID: number) {
        var data = {
            rlUserID: rlUserID
        };
        return this.toRLService<Models.IAspNetUserRole>("/api/identity/getuserroles").query(data).$promise;
    }
}